
export class ConnectionStatus {
private static names: string[] = ['connecting', 'connected', 'reconnecting', '', 'disconnected'];
private _value: Number;
/**
 * @return {?}
 */
get value(): Number {
        return this._value;
    }
/**
 * @return {?}
 */
get name(): string {
        return ConnectionStatus.names[Number.parseInt(this._value.toString())];
    }
/**
 * @param {?} value
 */
constructor(value: number) {
        if (value == null || value < 0) {
            throw new Error("Failed to create ConnectionStatus. Argument 'name' can not be null or empty.");
        }
        this._value = value;
    }
/**
 * @return {?}
 */
public toString(): string {
        return this.name;
    }
/**
 * @param {?} other
 * @return {?}
 */
public equals(other: ConnectionStatus): boolean {
        if (other == null) {
            return false;
        }
        return this._value === other.value;
    }
}

function ConnectionStatus_tsickle_Closure_declarations() {
/** @type {?} */
ConnectionStatus.names;
/** @type {?} */
ConnectionStatus.prototype._value;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
